<div class="agpr-briefingDateField">
    <agpr-checkbox
        id="briefingDateField_showDate"
        [label]="'Briefings.formField.date.showDateLabel' | localize"
        [(ngModel)]="$any(block.displayElement.styles).showDate"
        (ngModelChange)="blockChanged()"
        [binary]="true"
    ></agpr-checkbox>
    <div
        class="agpr-briefingDateField-schedulingTypes"
        *ngIf="$any(block?.displayElement.styles)?.showDate"
        role="radiogroup"
        [attr.aria-label]="'Briefings.formField.date.includeDateSettings' | localize"
    >
        <div class="agpr-briefingDateField-schedulingType">
            <agpr-radio
                [id]="id + '_showDate_send'"
                [value]="modeSendDate"
                label="Briefings.formField.sendDate"
                name="scheduling_type"
                hiddenLabel="Briefings.formField.sendDate"
                [(ngModel)]="mode"
                (ngModelChange)="modeChanged($event)"
            ></agpr-radio>
        </div>
        <div class="agpr-briefingDateField-schedulingType">
            <agpr-radio
                [id]="id + '_showDate_specific'"
                [value]="modeSpecificDate"
                label="Briefings.formField.specificDate"
                name="scheduling_type"
                hiddenLabel="Briefings.formField.specificDate"
                [(ngModel)]="mode"
                (ngModelChange)="modeChanged($event)"
            ></agpr-radio>
        </div>
        <div class="agpr-briefingDateField-specificDateSelector"
             [ngClass]="{
            'agpr-briefingDateField-specificDateSelector--active': mode === modeSpecificDate,
            'agpr-briefingDateField-specificDateSelector--inactive': mode !== modeSpecificDate
        }"
        >
            <div
                class="agpr-briefingDateField-date ui-fluid"
                [ngClass]="{
                    'agpr-briefingDateField-date--active': mode === modeSpecificDate
                }"
            >
                <div class="agpr-inputOverlay">
                    <agpr-date-picker
                        #startCalendar
                        [placeholder]="field.placeholder"
                        [(ngModel)]="_value"
                        (ngModelChange)="dateSelected($event)"
                    ></agpr-date-picker>
                </div>
            </div>
        </div>
        <div class="agpr-briefingDateField-schedulingType">
            <agpr-radio
                [id]="id + '_showDate_dateRange'"
                [value]="modeDateRange"
                label="Briefings.formField.dateRange"
                name="scheduling_type"
                hiddenLabel="Briefings.formField.dateRange"
                [(ngModel)]="mode"
                (ngModelChange)="modeChanged($event)"
            ></agpr-radio>
        </div>
        @if (mode === modeDateRange) {
            <div
                class="agpr-briefingDateField-dateRangeTypes"
                role="radiogroup"
                [attr.aria-label]="'Briefings.formField.date.dateRangeType' | localize"
            >
                <div class="agpr-briefingDateField-dateRangeType">
                    <agpr-radio
                        [id]="id + '_dateRange_specific'"
                        [value]="dateRangeTypeEnum.SPECIFIC"
                        label="Briefings.formField.date.specificDateRange"
                        name="date_range_type"
                        hiddenLabel="Briefings.formField.date.specificDateRange"
                        [(ngModel)]="selectedDateRangeType"
                        (ngModelChange)="dateRangeTypeChanged($event)"
                    ></agpr-radio>
                </div>
                @if (selectedDateRangeType === dateRangeTypeEnum.SPECIFIC) {
                    <div class="agpr-briefingDateField-dateRangePopup">
                        <agpr-date-query-popup
                            [id]="id + '_dateRange'"
                            [(ngModel)]="_dateQuery"
                            [options]="dateRangeOptions"
                            [hideDateTypeSelection]="true"
                            (ngModelChange)="dateRangeChanged($event)"
                        ></agpr-date-query-popup>
                    </div>
                }
                @if (isRecurring) {
                    <div class="agpr-briefingDateField-dateRangeType">
                        <agpr-radio
                            [id]="id + '_dateRange_recurrence'"
                            [value]="dateRangeTypeEnum.RECURRENCE"
                            label="Briefings.formField.date.recurrenceDateRange"
                            name="date_range_type"
                            hiddenLabel="Briefings.formField.date.recurrenceDateRange"
                            tooltip="Briefings.formField.date.recurrenceDateRange.tooltip"
                            [(ngModel)]="selectedDateRangeType"
                            (ngModelChange)="dateRangeTypeChanged($event)"
                        ></agpr-radio>
                    </div>
                }
            </div>
        }
    </div>

    @if (showViewInBrowser) {
        <div class="agpr-briefingDateField-showViewInBriefing">
            <div class="agpr-briefingDateField-showViewInBriefing-checkbox">
                <agpr-checkbox
                    id="briefingDateField_showViewInBriefing"
                    label="Briefings.formField.date.showViewInBrowserLabel"
                    infoCircleTooltip="Briefings.formField.date.showViewInBrowserLabel.tooltip"
                    [(ngModel)]="$any(block.displayElement.styles).showViewInBrowser"
                    (ngModelChange)="blockChanged()"
                    [binary]="true"
                ></agpr-checkbox>
            </div>
            <div
                class="agpr-briefingDateField-showViewInBrowserSection"
                *ngIf="$any(block?.displayElement?.styles)?.showViewInBrowser"
            >
                <agpr-text-input
                    [id]="'briefingDateField.viewInBriefingLabel'"
                    label="Briefings.formField.date.viewInBrowserLabel"
                    [(ngModel)]="$any(block.displayElement.styles).viewInBrowserLabel"
                    (ngModelChange)="blockChanged()"
                >
                </agpr-text-input>
            </div>
            <div
                *ngIf="field.description"
                class="agpr-formField-description"
            >
                {{ field.description | localize }}
            </div>
        </div>
    }
</div>
